import styled from 'styled-components'
import { theme } from '../../../../style/theme'

export const InvoicesFilterForm = styled.div`
	font-size: 1em;
	display: grid;
	grid-template-columns: minmax(7.85em, 14.38em);

	@media screen and (max-width: ${theme.point520}) {
		grid-template-columns: 1fr;
	}
`
InvoicesFilterForm.displayName = 'InvoicesFilterForm'
